import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["container", "id", "name", "disabled", "visible", "placeholder", "for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.loaded && _ctx.getPropertyBooleanValue(_ctx.BaseControlTypeConst.VISIBLE))
    ? _withDirectives((_openBlock(), _createElementBlock("label", {
        key: 0,
        container: _ctx.container,
        id: _ctx.getPropertyValue(_ctx.LabelTypeConst.ID),
        style: _normalizeStyle(_ctx.getPropertyValue(_ctx.LabelTypeConst.STYLE)),
        class: _normalizeClass({ [_ctx.getPropertyValue(_ctx.LabelTypeConst.CLASS) ?? '']: true, 'customrequired': _ctx.getPropertyBooleanValue(_ctx.LabelTypeConst.REQUIRED) }),
        name: _ctx.getPropertyValue(_ctx.LabelTypeConst.NAME),
        disabled: _ctx.getPropertyBooleanValue(_ctx.LabelTypeConst.DISABLED),
        visible: _ctx.getPropertyBooleanValue(_ctx.LabelTypeConst.VISIBLE),
        placeholder: _ctx.getPropertyValue(_ctx.LabelTypeConst.PLACEHOLDER),
        for: _ctx.getPropertyValue(_ctx.LabelTypeConst.FOR)
      }, [
        _createTextVNode(_toDisplayString(_ctx.getPropertyValue(_ctx.LabelTypeConst.TEXT)), 1 /* TEXT */)
      ], 14 /* CLASS, STYLE, PROPS */, _hoisted_1)), [
        [_directive_tooltip, _ctx.getPropertyValue(_ctx.LabelTypeConst.TOOLTIP)]
      ])
    : _createCommentVNode("v-if", true)
}